export default __webpack_public_path__ + "static/media/TEDxBITD 2021 Event Brochure.fb805acb.pdf";